/** Job date values are YYYY-MM-DD; keep them as calendar dates across time zones. */
export function formatJobDate(date: string | null | undefined): string {
  if (!date) return 'Unscheduled';
  const dateOnly = date.slice(0, 10);
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(dateOnly);
  if (!match) return date;
  return `${match[2]}/${match[3]}/${match[1]}`;
}

export function formatJobAssignee(assignee: { email: string } | null | undefined): string {
  return assignee?.email || 'Unassigned';
}

/** Amounts come from the backend as decimal strings. This formats display only. */
export function formatJobMoney(amount: string): string {
  const parsed = Number(amount);
  return Number.isFinite(parsed)
    ? parsed.toLocaleString('en-US', { style: 'currency', currency: 'USD' })
    : amount;
}
